export default __webpack_public_path__ + "static/media/DSC_7419.edd92ec7.jpg";